import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslocoLoader } from '@ngneat/transloco';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppTranslocoLoader implements TranslocoLoader {
  #http = inject(HttpClient);
  getTranslation(lang: string): Observable<any> {
    return this.#http.get(`/assets/i18n/${lang}.json`);
  }
}
